var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDaosquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46_1606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 1.88249e-08 20 1.21272e-08C8.95431 5.42954e-09 -5.42954e-09 8.95431 -1.21272e-08 20C-1.88249e-08 31.0457 8.95431 40 20 40Z",
    fill: "url(#paint0_linear_46_1606)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9345 28.9845C21.0707 29.5061 23.2065 29.419 25.629 29.8106C28.0515 30.2022 29.837 33.1933 30.3206 31.4235C31.0007 28.9342 29.3186 24.2746 27.8575 20.4637C27.8061 20.3296 29.3505 20.2497 30.3206 18.3991C30.895 17.3034 30.8831 14.5621 31.2658 13.6075C32.4558 10.6388 31.0609 11.378 30.9277 11.074C30.8456 10.8865 31.379 8.04541 30.5335 9.43246C30.3552 9.72495 28.7363 14.0451 28.3584 14.849C27.5107 16.6522 26.7571 16.8204 26.7062 16.6841C26.3547 16.246 26.1176 15.6343 25.9949 14.849C25.4111 11.1112 22.9348 8 19.1599 8C15.3849 8 12.3248 11.0664 12.3248 14.849C12.112 15.472 12.0055 16.0837 12.0055 16.6841C12.0055 16.9312 10.5592 18.1009 9.81858 18.9041C8.63762 20.1848 8.25218 21.5401 8.24356 21.9615C8.2387 22.2169 8.42983 24.5529 9.46161 24.0055C9.53223 23.968 9.64015 23.7055 9.78719 23.3506C9.99138 22.8578 10.269 22.1612 10.6291 21.6674C11.1467 20.9575 11.9246 20.766 12.0055 20.7673C11.989 23.0967 11.989 24.384 12.0055 24.629C12.1478 26.7394 12.6029 27.4166 13.7129 28.9845C14.4368 30.0071 15.505 30.4267 16.5894 29.8106C17.0357 29.5571 18.3085 28.238 19.9345 28.9845Z",
    fill: "url(#paint1_linear_46_1606)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.985 16.8433C23.495 16.8433 24.719 15.6035 24.719 14.0741C24.719 12.5447 23.495 11.3048 21.985 11.3048C20.475 11.3048 19.251 12.5447 19.251 14.0741C19.251 15.6035 20.475 16.8433 21.985 16.8433Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9477 16.0129C22.8898 15.7067 23.4395 14.7998 23.1754 13.987C22.9113 13.1743 21.9335 12.7637 20.9914 13.0698C20.0493 13.3759 19.4996 14.2829 19.7637 15.0956C20.0278 15.9083 21.0056 16.319 21.9477 16.0129Z",
    fill: "#160B0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4492 14.4729C22.6569 14.4729 22.8252 14.3046 22.8252 14.0969C22.8252 13.8892 22.6569 13.7208 22.4492 13.7208C22.2416 13.7208 22.0733 13.8892 22.0733 14.0969C22.0733 14.3046 22.2416 14.4729 22.4492 14.4729Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1431 23.2498C19.385 24.7298 21.1771 25.2704 22.146 24.4574C23.1149 23.6444 22.8936 21.7857 21.6518 20.3057C20.41 18.8258 18.6179 18.2851 17.649 19.0981C16.6801 19.9111 16.9013 21.7699 18.1431 23.2498Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0588 16.8433C15.5244 16.8433 15.9018 16.481 15.9018 16.0342C15.9018 15.5873 15.5244 15.2251 15.0588 15.2251C14.5932 15.2251 14.2158 15.5873 14.2158 16.0342C14.2158 16.481 14.5932 16.8433 15.0588 16.8433Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.412 15.9772C15.5063 15.9772 15.5828 15.9007 15.5828 15.8063C15.5828 15.7119 15.5063 15.6353 15.412 15.6353C15.3176 15.6353 15.2411 15.7119 15.2411 15.8063C15.2411 15.9007 15.3176 15.9772 15.412 15.9772Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_46_1606",
    x1: 22.0663,
    y1: -5.00561,
    x2: 22.0663,
    y2: 35.3984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF96D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD390"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_46_1606",
    x1: 19.9932,
    y1: 8,
    x2: 19.9932,
    y2: 31.9789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0C02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43003E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46_1606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaosquare);
export default __webpack_public_path__ + "static/media/daosquare.e804e4a84a9c1ecaa9b9c50590810574.svg";
export { ForwardRef as ReactComponent };